import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const ArcelikSari = '#FF9800';
const siyah = '#424242';

export default {
  primary: {
    contrastText: ArcelikSari,
    dark: ArcelikSari,
    main: ArcelikSari,
    light: ArcelikSari
  },
  secondary: {
    contrastText: ArcelikSari,
    dark: siyah,
    main: siyah,
    light: siyah
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
